import { useState, useCallback } from 'react';

const KEY = 'defera_all_in_prices';

/**
 * Customer preference for how prices are displayed while shopping:
 * true (default) → all-in totals with taxes & fees; false → raw base fares,
 * always labeled "fare" so the smaller number never masquerades as a total.
 *
 * Persisted in localStorage so the choice made on search results sticks
 * through the booking-options page (each page reads it on mount — same-tab
 * navigation is the only flow that matters here). Checkout ignores the
 * preference on purpose: the Review page always shows the real trip total.
 */
export function useAllInPrices() {
  const [showAllIn, setShowAllInState] = useState(() => {
    try {
      return window.localStorage.getItem(KEY) !== '0';
    } catch {
      return true;
    }
  });
  const setShowAllIn = useCallback((value) => {
    setShowAllInState(Boolean(value));
    try {
      window.localStorage.setItem(KEY, value ? '1' : '0');
    } catch {
      /* private mode — session-only preference is fine */
    }
  }, []);
  return [showAllIn, setShowAllIn];
}
